import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Postnoviciat = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Постновіціат - Філософія</h1>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-3 pb-3">
            Складання перших обітів відкриває новий етап богопосвяченого життя. У цей час співбрат, за підтримки спільноти та духовного провідника, продовжує процес дозрівання на шляху до вічних обітів і розвиває різні виміри свого покликання — як салезіянин-брат або як кандидат до священства.          </div>
          <div className="pt-3 pb-3">
            Під час постновіціату салезіянин поглиблює віру, дух отця Боско, а також здобуває філософську, педагогічну й катехитичну підготовку (Статут 114). Формація у студентаті Салезіян має на меті цілісний розвиток особи, який охоплює:          </div>
          <ul className="pl-6 list-decimal">
            <li>
              Людську формацію — зростання у фізичному, емоційному та психологічному вимірах;


            </li>
            <li>
              Духовну формацію — поглиблення молитви, віри та особистої відповідальності за покликання;            </li>
            <li>
              Академічну формацію — засвоєння богословських і світських наук, необхідних для життя та служіння;            </li>
            <li>
              Спільнотну формацію — розвиток уміння будувати здорові стосунки у братерстві;


            </li>
            <li>
              Пасторальну формацію — виховання здатності до апостольської праці, особливо серед убогих і потребуючих.            </li>
          </ul>
          <div className="pt-3 pb-3">
            Філософські студії наші співбрати проходять у Римі. Навчання триває два роки.
          </div>
          📍 Студентат: Рим
        </div>
      </div >
    </>
  );
};

export default Postnoviciat;
